import { render } from "./MainTwo.vue?vue&type=template&id=d3fc7afa&scoped=true"
import script from "./MainTwo.vue?vue&type=script&lang=js"
export * from "./MainTwo.vue?vue&type=script&lang=js"

import "./MainTwo.vue?vue&type=style&index=0&id=d3fc7afa&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3fc7afa"]])

export default __exports__